import {
  prepareProgramAndDependentData,
  removeOrderNameForCloneProgramFlow,
} from './pre-transformers';
import { Parameters } from './program-wizard/parameters';
import { ProductDetails } from './program-wizard/product-details/ProductDetails';
import {
  ProgramTransformer,
  ProgramWizardConfig,
  ProgramWizardStepInfo,
} from '@/app/core/components/program-wizard';
import {
  // amendSubscriberCode,
  ensureValidCloneFromProgramExists,
} from '@/app/features/products/common';
import { AscendUSAAProgram, sequencePromiseFunctions } from '@ssar-app/domain';

export const getAscendUSAAProgramWizardConfig =
  async (): Promise<ProgramWizardConfig> => {
    const preTransformer: ProgramTransformer = sequencePromiseFunctions(
      ensureValidCloneFromProgramExists,
      // amendSubscriberCode,
      removeOrderNameForCloneProgramFlow,
      prepareProgramAndDependentData,
    );

    const programKeys = {
      'Program Details': ['productInput', 'productDetails'],
      Parameters: ['packagesInput', 'parameters'],
    };

    const steps: ProgramWizardStepInfo[] = [
      {
        key: programKeys['Program Details'],
        title: 'Program Details',
        description: 'Enter program details',
        element: <ProductDetails keys={programKeys['Program Details']} />,
      },
      {
        key: programKeys['Parameters'],
        title: 'Parameters',
        description: 'Enter mandatory & optional parameters',
        element: <Parameters keys={programKeys['Parameters']} />,
      },
    ];
    const toReturn: ProgramWizardConfig = {
      steps,
      preTransformer,
      isSaveDraftsAllowed: true,
      isAutoSaveAllowed: true,
      autoSaveTimer: 30 * 1000,
    };
    return Promise.resolve(toReturn);
  };

export const getProgramName = (model: AscendUSAAProgram) => {
  return model?.productInput?.productDetails?.programName || '';
};
